import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MenuService {
  protected homeMenuSubject = new Subject();

  public homeMenu$ = this.homeMenuSubject.asObservable();

  public selectHomeMenu(value: boolean) {
    this.homeMenuSubject.next(true);
  }
}
